import { Component, OnInit } from '@angular/core';
import { NivelSigilo } from '../../models/nivel-sigilo.enum';
import { SelectItem } from 'primeng/api';
import { SelectItemService } from '../../services/select-item.service';
import { UsuarioPermissao } from '../usuario-permissao.model';
import { UsuarioPermissaoService } from '../usuario-permissao.service';
import { ConfirmacaoService, MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSourceRouted } from '../../util/data-source-routed';

@Component({
  selector: 'app-usuario-permissao-lista',
  templateUrl: './usuario-permissao-lista.component.html',
  styleUrls: ['./usuario-permissao-lista.component.css'],
})
export class UsuarioPermissaoListaComponent implements OnInit {
  ds: DataSourceRouted<UsuarioPermissao, number>;
  public nivelSigiloItens: SelectItem[];
  public abrangenciaItens: SelectItem[];
  public vigenteItens: SelectItem[];
  public origemItens: SelectItem[];

  constructor(
    private service: UsuarioPermissaoService,
    private confirmacaoService: ConfirmacaoService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<UsuarioPermissao, number>(
      'administracao-usuario-permissao',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({
          atributo: 'id',
          operador: RestricaoOperador.EQUALS,
        }),
        new Restricao<string>({
          atributo: 'usuario.nome',
          operador: RestricaoOperador.START_WITH,
        }),
        new Restricao<string>({
          atributo: 'perfil.nome',
          operador: RestricaoOperador.START_WITH,
        }),
        new Restricao<boolean>({
          atributo: 'vigente',
          operador: RestricaoOperador.IN,
          valores: [true],
        }),
        new Restricao<string>({
          atributo: 'origem',
          operador: RestricaoOperador.IN,
        }),
        new Restricao<string>({
          atributo: 'abrangencia',
          operador: RestricaoOperador.IN,
        }),
        new Restricao<string>({
          atributo: 'fonteDados.nome',
          operador: RestricaoOperador.CONTAINS,
        }),
        new Restricao<string>({
          atributo: 'orgaoJustica.nome',
          operador: RestricaoOperador.CONTAINS,
        }),
        new Restricao<string>({
          atributo: 'orgaoJulgador.nome',
          operador: RestricaoOperador.CONTAINS,
        }),
        new Restricao<string>({
          atributo: 'orgaoJulgadorColegiado.nome',
          operador: RestricaoOperador.CONTAINS,
        }),
        new Restricao<string>({
          atributo: 'limiteNivelSigilo',
          operador: RestricaoOperador.IN,
        }),
      ])
    );
  }

  ngOnInit(): void {
    this.nivelSigiloItens = this.selectItemService.getLimiteNivelSigiloItens();
    this.abrangenciaItens = this.selectItemService.getPermissaoAbrangenciaItens();
    this.vigenteItens = this.selectItemService.getSimNaoItens();
    this.origemItens = this.selectItemService.getOrigemItens();
  }

  public getLimiteNivelSigiloDescricao(limiteNivelSigilo: NivelSigilo): string {
    return this.nivelSigiloItens.filter((item) => item.value === limiteNivelSigilo)[0].label;
  }

  public encerrarVigencia(entidade: UsuarioPermissao): void {
    this.confirmacaoService.confirmar({
      mensagem: 'Você tem certeza que deseja encerrar a vigência da permissão do usuário?',
      aceitar: () => {
        this.service
          .encerrarVigencia(entidade)
          .then(() => {
            this.ds.atualizar();
          })
          .catch((response) => {
            this.mensagemService.addErro('Erro ao encerrar a vigência da permissão do usuário', response.error);
          });
      },
    });
  }
}
